import {
	LOGIN,
	REGISTER_SUCCESS,
	LOGOUT,
	REQUEST_OTP,
	FORGOT_PASSWORD,
	CHANGE_PASSWORD,
	GET_USER_INFO,
	REQUEST_OTP_ERROR,
	VERIFY_USER,
	UPDATE_USER_GROUP,
	UPDATE_USER_MID,
	GET_USER_GROUP_LIST,
	RESET_USER_GROUP_LIST,
	SET_CAPTCHA_TOKEN,
	SET_CAPTCHA_ERROR,
	RESET_FORGOT_PASSWORD,
} from './types';

const loginRequesting = (payload, captcha) => ({
	type: LOGIN,
	payload,
	captcha,
});

const registerSuccessAction = (payload) => ({
	type: REGISTER_SUCCESS,
	payload,
});

const requestingOTP = (payload) => ({
	type: REQUEST_OTP,
	payload,
});

const logout = () => ({
	type: LOGOUT,
});

const forgotPasswordLink = (payload) => ({
	type: FORGOT_PASSWORD,
	payload,
});

const changePassword = (payload) => ({
	type: CHANGE_PASSWORD,
	payload,
});

const getUserInfo = () => ({
	type: GET_USER_INFO,
});

const changeOtpStatus = () => ({
	type: REQUEST_OTP_ERROR,
});

const updateUserGroup = (payload) => ({
	type: UPDATE_USER_GROUP,
	payload,
});

const userVerification = (verificationKey) => ({
	type: VERIFY_USER,
	verificationKey,
});

const getUserGroupList = (payload) => ({
	type: GET_USER_GROUP_LIST,
	payload,
});

const updateUserMID = (payload) => ({
	type: UPDATE_USER_MID,
	payload,
});

const resetUserGroupList = () => ({
	type: RESET_USER_GROUP_LIST,
});

const resetForgotPassword = () => ({
	type: RESET_FORGOT_PASSWORD,
});

const setCaptchaToken = (value) => ({
	type: SET_CAPTCHA_TOKEN,
	value,
});

const setCaptchaError = (captchaError) => ({
	type: SET_CAPTCHA_ERROR,
	captchaError,
});

export {
	loginRequesting,
	registerSuccessAction,
	requestingOTP,
	logout,
	forgotPasswordLink,
	changePassword,
	getUserInfo,
	changeOtpStatus,
	userVerification,
	updateUserGroup,
	getUserGroupList,
	updateUserMID,
	resetUserGroupList,
	setCaptchaToken,
	setCaptchaError,
	resetForgotPassword,
};
